import { COMPANIES } from "../constants";
import { getCategoryList } from "../helpers/category";
import { getSelectedFilters } from "../helpers/filter";
import { getBookingOptionsPriceBounds, resolvePerPersonPriceFilterRange } from "../helpers/pricing";
import { isFeaturedWeek, isWeekComingSoon, isWeekSoldOut } from "../helpers/week";
import history from "../history";
import { store } from "../store/configureStore";

export const filterBookingOptions = () => dispatch => {
  const state = store.getState();
  const { bookingOptions } = state;
  const destinations = state.destinations.items;
  const cabins = state.cabins.data;
  const selectedFilters = getSelectedFilters(history.location);
  const { minPrice, maxPrice } = selectedFilters;

  let { cheapestPrice, mostExpensivePrice } = getBookingOptionsPriceBounds(
    bookingOptions.items,
    cabins,
    destinations,
    history.location
  );

  const { min: rangeMin, max: rangeMax, hasExplicitPriceFilter: explicitPriceFilter } = resolvePerPersonPriceFilterRange(
    minPrice,
    maxPrice,
    cheapestPrice,
    mostExpensivePrice
  );

  dispatch({
    type: 'FILTER_BOOKING_OPTIONS',
    payload: {
      ...selectedFilters,
      destinations,
      cabins,
      hasExplicitPriceFilter: explicitPriceFilter,
      priceRange: {
        min: rangeMin,
        max: rangeMax
      }
    },
    cheapestPrice,
    mostExpensivePrice
  });
  return null;
};

export const sortBookingOptions = sortBy => dispatch => {
  dispatch({
    type: 'SORT_BOOKING_OPTIONS',
    payload: {
      sortBy
    }
  });
  return null;
};

export const buildBookingOptions = (destinations, cabins, plans = null, companyId = COMPANIES.DAY8) => dispatch => {
  const weeks = destinations && destinations.length > 0 && destinations.reduce((acc, item) => {
    const validWeeksForDestination = item.weeks;
    return [...acc, ...validWeeksForDestination];
  }, []) || [];
  const bookingOptions = weeks.filter(w => w.company.id === companyId).reduce((acc, week) => {
    const pathname = ''; // that's just to generate link on categories page... not needed here
    const categoryList = getCategoryList(week.destination.standardYachts, destinations, history.location, cabins, history, pathname, week).filter(c => !c.isUnavailable);
    week.soldOut = isWeekSoldOut(week);
    week.comingSoon = isWeekComingSoon(week);
    week.featured = isFeaturedWeek(week);
    categoryList.filter(c => !c.isUnavailable).forEach(category => {
      const standardYachtWeek = week.standardYachtWeeks.find(
        syw => `${syw.standardYacht.package.id}` === `${category.data.package.id}`
      );
      // category here has data about sold out etc...
      acc.push({
        week,
        category,
        standardYachtWeek,
        isSavedPlan: plans && plans.some(plan => plan.standardYachtWeek?.id === standardYachtWeek?.id)
      });
    });
    // Add one "Custom yacht option"
    acc.push({
      week,
      category: null,
      standardYachtWeek: null,
      isSavedPlan: false
    });
    return acc;
  }, []);
  const { cheapestPrice, mostExpensivePrice } = getBookingOptionsPriceBounds(bookingOptions, cabins, destinations, history.location);
  dispatch({
    type: 'SAVE_BOOKING_OPTIONS',
    bookingOptions,
    cheapestPrice,
    mostExpensivePrice
  });
};
